module.exports = __webpack_public_path__ + "img/mastercard.855dbb1.png";